import Cookies from "universal-cookie";
import {isEmpty, isTrue} from "./generalUtils";
import {COOKIE_MAX_AGE} from "../modules/_MODULE_GLOBALS/constants";

const COOKIE_NAMES = {
	SUBSCRIBER_ID: 'subscriber_id',
	LOOKINSIDE_IDS: 'lookinside_ids',
	LOGIN_ID: 'login_id'
};

export { COOKIE_NAMES };

const getCookie = (req, key) => {
	const cookies = !isEmpty(req) && !isEmpty(req.headers) ? new Cookies(req.headers.cookie) : new Cookies();
	const cookieValue = cookies.get(key);
	if (!isEmpty(cookieValue)) {
		return cookieValue;
	} else {
		return null;
	}

};

export { getCookie };


const setCookie = (req, key, value, options) => {
	options = Object.assign({
		path: "/",
		domain: '',
		secure: false,
		httpOnly: false,
		sameSite: "none",
		expires: null,
		maxAge: COOKIE_MAX_AGE.SIXTY_DAYS_SECONDS  // 60 days
	}, options);

	const cookieOptions = {
		path: options.path,
		secure: isTrue(options.secure, {default: false}),
		httpOnly: isTrue(options.httpOnly, {default: false}),
		sameSite: options.sameSite
		//sameSite: isTrue(options.secure, {default: false}) ? options.sameSite : "lax"
	};
	if (!isEmpty(options.expires)) {
		cookieOptions.expires = options.expires;
	} else {
		cookieOptions.maxAge = options.maxAge;
	}
	if (!isEmpty(options.domain)) {
		cookieOptions.domain = options.domain;
	}

	const cookies = !isEmpty(req) && !isEmpty(req.headers) ? new Cookies(req.headers.cookie) : new Cookies();
//	cookies.set(key, value, {path: path, secure: secure, httpOnly: httpOnly, sameSite: sameSite, maxAge: maxAge});
	cookies.set(key, value, {...cookieOptions});

//	cookies.set("fla", "five", {path: "/" + collectionUrl, secure: false, httpOnly: false, sameSite: "None", maxAge: (3600 * 24 * 60)});
};

export { setCookie };
